import { message as antMessage } from "antd";
import API from "API";
import { getCookie, removeCookie, setCookie } from "general_function";
import { createContext, useCallback, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [firstGettingUser, setFirstGettingUser] = useState(true);
    const [message, contextHolder] = antMessage.useMessage();

    const getUserInfo = useCallback((setLoading) => {
        if (!getCookie("usertoken")) {
            setFirstGettingUser(false);
            return;
        }
        if (setLoading) setLoading(true);
        API.get("get-user-info/")
            .then((res) => {
                setUser(res.data);
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    removeCookie("usertoken");
                }
                console.log(error);
            })
            .finally(() => {
                if (setLoading) setLoading(false);
                setFirstGettingUser(false);
            });
    },[]);

    const login = useCallback((data, setLoading) => {
        if (getCookie("usertoken")) {
            removeCookie("usertoken")
        }
        setLoading(true);
        API.post("login/", data)
            .then((res) => {
                setCookie("usertoken", res.data.token);
                getUserInfo(setLoading);
            })
            .catch((error) => {
                if (error.response?.status === 400) {
                    console.log('?')
                    message.error("Sai tên đăng nhập hoặc mật khẩu");
                }
                setLoading(false);
                console.log(error);
            })
            .finally(() => {});
        setCookie();
    },[getUserInfo]);

    const logout = useCallback(() => {
        removeCookie("usertoken");
        setUser(null);
    },[]);

    return (
        <AuthContext.Provider
            value={{ user, setUser, getUserInfo, login, logout, firstGettingUser }}
        >
            { contextHolder }
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
